// extracted by mini-css-extract-plugin
export default {"root":"WarningBox_root__A0tLg","title":"WarningBox_title__50iFx","content":"WarningBox_content__f28Rk"};